module.exports = __webpack_public_path__ + "img/icon-service2.5a168d2e.png";